import React from "react"; 
import { Link } from "react-router-dom";    
import CreateUserTypeForm from "./CreateUserTypesForm";

const CreateUserType = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>Create User Type</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Create User Type</li>
        </ul>
      </div> */}

      <CreateUserTypeForm />
    </>
  );
};

export default CreateUserType;
